import io from 'socket.io-client';

export function createConnection({ userId } = {}) {
  return io(import.meta.env.VITE_DEAL_API_SOCKET_URL, {
    withCredentials: false,
    transports: ['websocket'],
    ...(userId ? { query: { user_id: userId } } : {}),
  });
}
